"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const immutable_1 = require("immutable");
const SettingsRounded_1 = __importDefault(require("@mui/icons-material/SettingsRounded"));
const feature_flags_1 = require("companion-app-components/flux/feature-flags");
const defaults_1 = require("data/preferences/defaults");
const QMenu_1 = __importDefault(require("components/QMenu"));
const useQPreferences_1 = __importDefault(require("components/QPreferences/useQPreferences"));
const QHelp_1 = __importDefault(require("components/QHelp"));
const transactionsConfig_1 = require("components/TransactionRegister/transactionsConfig");
const compose_1 = __importDefault(require("utils/compose"));
const TxPrefMenu = ({ selected: initialSelected, onChange, customItems, accountType, showQHelp, showIsReviewedColumn = true, isWindowsDataset, }) => {
    const { datasetPreferences, setDatasetPreference } = (0, useQPreferences_1.default)();
    const [selected, setSelected] = (0, react_1.useState)(initialSelected);
    const [displayColumnsKey, setDisplayColumnsKey] = (0, react_1.useState)((0, defaults_1.regFieldsSortType)(datasetPreferences.transactionRegister.regFieldsSort, accountType));
    const prefShowPreferences = (0, react_redux_1.useSelector)((state) => feature_flags_1.featureFlagsSelectors.getFeatureFlags(state)).get('prefShowPreferences');
    (0, react_1.useEffect)(() => {
        setSelected(initialSelected);
    }, [initialSelected]);
    (0, react_1.useEffect)(() => {
        setDisplayColumnsKey((0, defaults_1.regFieldsSortType)(datasetPreferences.transactionRegister.regFieldsSort, accountType));
    }, [datasetPreferences, accountType]);
    const fieldIsChecked = (0, react_1.useCallback)((field) => datasetPreferences.transactionRegister.regFieldsSort[displayColumnsKey].includes(field), [datasetPreferences, displayColumnsKey]);
    const calculateInsertPosition = (0, react_1.useCallback)((regSort, fieldObj) => regSort.findIndex((x) => transactionsConfig_1.fieldData[x].position > fieldObj.position), []);
    const resetDefaults = (0, react_1.useCallback)(() => {
        const regSort = (0, immutable_1.List)((0, transactionsConfig_1.getColumnDefaults)(accountType));
        const newPref = { transactionRegister: { regFieldsSort: { [displayColumnsKey]: regSort } } };
        setDatasetPreference(newPref);
    }, [accountType, displayColumnsKey, setDatasetPreference]);
    const handleChange = (0, react_1.useCallback)((value, groupId) => {
        if (groupId === 'txnColumns') {
            let regSort = datasetPreferences.transactionRegister.regFieldsSort[displayColumnsKey];
            if (fieldIsChecked(value)) {
                const index = regSort.indexOf(value);
                if (index >= 0) {
                    regSort = regSort.delete(index);
                    const newPref = { transactionRegister: { regFieldsSort: { [displayColumnsKey]: regSort } } };
                    setDatasetPreference(newPref);
                }
            }
            else {
                const slot = calculateInsertPosition(regSort, transactionsConfig_1.fieldData[value]);
                regSort = regSort.insert(slot, value);
                const newPref = { transactionRegister: { regFieldsSort: { [displayColumnsKey]: regSort } } };
                setDatasetPreference(newPref);
            }
            return;
        }
        if (value === 'resetDefaults') {
            resetDefaults();
            return;
        }
        if (value === 'reviewedHelp') {
            showQHelp('windowsReviewed');
            return;
        }
        if (onChange) {
            onChange(value);
        }
    }, [datasetPreferences, displayColumnsKey, setDatasetPreference, showQHelp, onChange, calculateInsertPosition, fieldIsChecked, resetDefaults]);
    const availableColumns = (0, transactionsConfig_1.getAvailableColumns)(accountType).map((field, index) => ({
        noCloseOnClick: true,
        selected: fieldIsChecked(field),
        label: transactionsConfig_1.fieldData[field].label,
        value: field,
        divider: index === (0, transactionsConfig_1.getAvailableColumns)(accountType).length - 1,
    }));
    const menuItems = [
        {
            label: 'Transaction Columns',
            groupId: 'txnColumns',
            isGroupList: true,
            groupList: showIsReviewedColumn ? availableColumns : availableColumns.filter((field) => field.value !== 'reviewed'),
        },
        { label: 'Reset Defaults', value: 'resetDefaults' },
    ];
    if (showIsReviewedColumn && isWindowsDataset) {
        menuItems.push({ label: 'About Reviewed...', value: 'reviewedHelp' });
    }
    let options = [
        {
            label: 'Transaction Display',
            groupId: 'txnDisplay',
            isGroupList: true,
            selected,
            groupList: [
                { label: 'Comfortable', value: 'comfortable' },
                { label: 'Normal', value: 'normal' },
                { label: 'Compact', value: 'compact', divider: true },
            ],
        },
        {
            label: 'Show/Hide Columns',
            value: 'txcols',
            subMenu: menuItems,
            itemOpensMenu: true,
        },
    ];
    if (prefShowPreferences) {
        options.push({
            label: 'Preferences...',
            value: 'preferences',
            divider: Boolean(customItems),
        });
    }
    if (customItems) {
        options = options.concat(customItems);
    }
    return (<div>
      <QMenu_1.default name="txpref" title="Transactions Settings" menuIcon={SettingsRounded_1.default} menuIconButtonSize="small-target" options={options} onChange={handleChange}/>
    </div>);
};
exports.default = (0, compose_1.default)((0, QHelp_1.default)())(TxPrefMenu);
